
import * as z from 'zod';

export const tripFormSchema = z.object({
  name: z.string().min(3, {
    message: "Trip name must be at least 3 characters.",
  }),
  startDate: z.date({
    required_error: "Start date is required.",
  }),
  endDate: z.date({
    required_error: "End date is required.",
  }),
  destination: z.string().min(2, {
    message: "Destination is required.",
  }),
  description: z.string().optional(),
}).refine(data => data.endDate >= data.startDate, {
  message: "End date must be after or equal to start date.",
  path: ["endDate"], 
});

export type TripFormValues = z.infer<typeof tripFormSchema>;
